import bg1 from 'assets/img/bg1.jpg'
import bg2 from 'assets/img/bg2.jpg'
import bg3 from 'assets/img/bg3.jpg'
import bg4 from 'assets/img/bg4.jpg'

const background = { bg1, bg2, bg3, bg4 }

export default background
